import { Body1, Body1Strong, Button, DataGrid, DataGridBody, DataGridCell, DataGridHeader, DataGridHeaderCell, 
  DataGridRow, Label, Link, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, Spinner, Subtitle1, TableCellLayout, 
  Title1, createTableColumn, makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ArrowLeftFilled,
  History32Regular
} from "@fluentui/react-icons";

import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { makeDecimalNumber } from '../../helpers/NumberFunction';

const homeStyles = {
    border: 0,
    margin: 0,
    width: '100%',
    minWidth: 'calc(100vw - 310px)',
    background: '#FAF9F8',
    position: 'relative',
  };

  const useStyles = makeStyles({
    root: {
        display: "flex",
        // backgroundColor: "#fff",
        flexDirection: "column",
        width: "660px",
    },
    detail: {
        // ...shorthands.border("2px", "solid", "#ccc"),
        // ...shorthands.overflow("hidden"),
        display: "flex",
        // height: "480px",
        backgroundColor: "#fff",
        ...shorthands.gap("20px"),
        justifyContent: "center",
        ...shorthands.padding("20px"),
        // ...shorthands.border("2px", "solid", "#ccc"),
        // boxShadow: "0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)",
        ...shorthands.borderRadius("10px"),
        boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",

    },
    userDetail: {
        // ...shorthands.border("2px", "solid", "#ccc"),
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "400px",
        width: "505px",
        ...shorthands.padding("10px", "20px"),
        ...shorthands.borderRadius("10px"),
        boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",
    },
    paymentDetail: {
        ...shorthands.border("2px", "solid", "#ccc"),
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "400px",
        width: "319px",
        ...shorthands.padding("10px", "20px"),
        ...shorthands.borderRadius("10px")
    },
    flex: {
      display: "flex", 
      justifyContent: "end", 
      alignItems: "center",
      ...shorthands.gap("20px"),
    },
    flexLeft: {
      display: "flex", 
      justifyContent: "start", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    contentSpacing: {
      display: "flex", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    stack: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      width: 'auto',
      height: 'auto',
      boxSizing: 'border-box',
      '> *': {
        textOverflow: 'ellipsis',
      },
      '> :not(:first-child)': {
        marginTop: '0px',
      },
      '> *:not(.ms-StackItem)': {
        flexShrink: 1,
      },
    },
    vertical: {
      display: 'flex',
      flexDirection: 'column',
    },
    verticalCenter: {
      display: 'flex',
      alignItems: "center"
    },
    fullWidth: {
      width: "100%"
    },
    spaceBetween: {
      justifyContent: "space-between"
    },
    columnGap: {
      ...shorthands.gap("0px", "10px"),
    },
    rowGap: {
      ...shorthands.gap("10px", "0px"),
    },
    horizontalCenter: {
      display: "flex",
      justifyContent: "center"
    }
  });

//   const slideDown = keyframes`
//   from {
//     transform: translateY(-100%);
//   }
//   to {
//     transform: translateY(0);
//   }
// `;

// const AnimatedRow = styled.tr`
//   border: 1px solid black;
//   padding: 8px;
//   animation: ${slideDown} 0.5s ease;
// `;

const API_URL = process.env.REACT_APP_API_URL;

const onFormatDate = (date, format) => {
  if (format === 'CE') {
    return `${date.getDate()}`.padStart(2, '0') + '/' + `${date.getMonth() + 1}`.padStart(2, '0') + '/' + date.getFullYear();
  } else {
    return `${date.getDate()}`.padStart(2, '0') + '/' + `${date.getMonth() + 1}`.padStart(2, '0') + '/' + (date.getFullYear() + 543);
  }
};

const getCellFocusMode = (columnId) => {
  switch (columnId) {
    case "file":
      return "none";
    default:
      return "cell";
  }
};
const columnSizingOptions = {
  number: {
    minWidth: 80,
    defaultWidth: 120,
  },
  dueDate: {
    minWidth: 80,
    defaultWidth: 120,
  },
  total: {
    minWidth: 85,
    defaultWidth: 120,
  },
  status: {
    minWidth: 90,
    defaultWidth: 120,
  },
  file: {
    minWidth: 80,
    defaultWidth: 100,
  },
  receiptTaxInvoice: {
    minWidth: 80,
    defaultWidth: 100,
  },
};

const PaymentHistory = () => {
  const history = useHistory();
    const styles = useStyles();

    const { t } = useTranslation();

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const [companyData, setCompanyData] = useState(null);

    const refMap = React.useRef({});
    const [items, setItems] = useState([])

    const companyId = sessionStorage.getItem('companyId') || '';

    const [loading, setLoading] = useState(true)

    const [manual, setManual] = useState(true)

    const [getCompanyDetailSuccess, setGetCompanyDetailSuccess] = useState(false)
    const [getPackageSuccess, setGetPackageSuccess] = useState(false)

    useEffect(() => {
      if (getCompanyDetailSuccess && getPackageSuccess) {
        setLoading(false)
      }
    }, [getCompanyDetailSuccess, getPackageSuccess])

    function getPaidStatements() {
      const documentsListEndpoint = `${API_URL}/documents/billings?status=all`
    
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const statementResponse = await axios.get(documentsListEndpoint, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    },
                                  })

                                  console.log("statementResponse", statementResponse)
        const documents = statementResponse.data.data?.documents || []

        // const paidDocuments = documents.filter(_document => _document.data.status === "paid")
        // console.log("paidDocuments", paidDocuments)

        // setItems(paidDocuments)

        // const testPaidDocuments = paidDocuments.map((_doc, index) => {
        //   if (index === 0) return _doc
        //   return {..._doc, receiptTaxInvoiceJobId: "test-id"}
        // })
        
        setItems(documents)

        setGetPackageSuccess(true)
        
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }

    async function fetchCompanyData() {
      // console.log('userEffect retrieve company and accounts data!');
  
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          console.log('tokenResponse: ', tokenResponse);
  
          axios
            .get(API_URL + '/etax/companies', {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .then(
              (response) => {
                // console.log(response);
  
                if (response.data.length === 0) {
                } else {
  
                  let _cid = ""
                  if (sessionStorage.getItem("companyId") && response.data.find(_company => _company.id === sessionStorage.getItem("companyId"))) {
                    setCompanyData(response.data.find(_company => _company.id === sessionStorage.getItem("companyId")));

                    // console.log(response.data.find(_company => _company.id === sessionStorage.getItem("companyId")))
                    // sessionStorage.setItem("companyId", response.data[0].id);
                    _cid = sessionStorage.getItem("companyId")
                  } else {
                    setCompanyData(response.data[0]);
                    sessionStorage.setItem("companyId", response.data[0].id);
  
                    _cid = response.data[0].id
                  }
  
                  axios
                      // .get(API_URL + '/companies-details/' + response.data[0].id, {
                      .get(API_URL + '/companies-details', {
                          headers: {
                              Authorization: 'Bearer ' + tokenResponse.accessToken,
                              'cid': _cid
                          },
                      })
                      .then((companiesDetailsResponse) => {
                        if (companiesDetailsResponse.data.billings === undefined || companiesDetailsResponse.data.billings.manual === undefined || companiesDetailsResponse.data.billings.manual) {
                          setManual(true)
                          setLoading(false)

                          // history.push({
                          //   pathname: '/etax/documents/all',
                          //   state: {},
                          // });
                        } else {
                          setManual(false)
                        }

                        setGetCompanyDetailSuccess(true)
  
                      })
                      .catch((error) => {
                          console.log(error);
                      })
                   }
              },
              (error) => {
                console.log(error);
              }
            );
        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
        });
    }

    useEffect(() => {
      fetchCompanyData()
      getPaidStatements()
  
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const openFileBillingPdf = (item) => {
      setLoading(true);

      history.push({
        pathname: '/billings/pdf/view',
        state: {
          item: {
            number: item.data.number,
            signature: item.signatures[0].certificateName,
            digitalSign: item.digitalSign,
            key: item.id,
            createdTimeValue: item.createdTime,
            type: item.type,
            fileExtension: item.data.fileExtension,
          },
          backUrl: "/billings/histories",
        },
      });
    };

    const openFileReceiptPdf = (item) => {
      setLoading(true);

      // console.log("item", item)

      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const receiptTaxinvoiceEndpoint = `${API_URL}/frevation/documents/billings/` + item.data.receiptTaxInvoiceId 
        // const receiptTaxinvoiceEndpoint = `http://localhost:7071/api/frevation/documents/billings/` + item.data.receiptTaxInvoiceId 
    
        const receiptTaxinvoiceResponse = await axios.get(receiptTaxinvoiceEndpoint, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    },
                                  })

        const receiptTaxInvoiceData = receiptTaxinvoiceResponse.data

        if (receiptTaxInvoiceData) {
          history.push({
            pathname: '/billings/pdf/view',
            state: {
              item: {
                number: receiptTaxInvoiceData.data.number,
                signature: receiptTaxInvoiceData.signatures[0].certificateName,
                digitalSign: receiptTaxInvoiceData.digitalSign,
                key: receiptTaxInvoiceData.id,
                createdTimeValue: receiptTaxInvoiceData.createdTime,
                type: receiptTaxInvoiceData.type,
                fileExtension: receiptTaxInvoiceData.data.fileExtension,
              },
              backUrl: "/billings/histories",
            },
          });
        }
      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    };

    const columns = [
      // createTableColumn({
      //   columnId: "file",
      //   compare: (a, b) => {
      //     return a.file.label.localeCompare(b.file.label);
      //   },
      //   renderHeaderCell: () => {
      //     return "File";
      //   },
      //   renderCell: (item) => {
      //     return (
      //       <TableCellLayout truncate media={item.file.icon}>
      //         {item.file.label}
      //       </TableCellLayout>
      //     );
      //   },
      // }),
      createTableColumn({
        columnId: "number",
        compare: (a, b) => {
          return a.data.number.localeCompare(b.data.number);
        },
        renderHeaderCell: () => {
          return t(`paymentHistory.number`);
        },
        renderCell: (item) => {
          return (
            <Label size="small">{item.data.number}</Label>
          );
        },
      }),
      createTableColumn({
        columnId: "dueDate",
        compare: (a, b) => {
          return a.data.dueDate.localeCompare(b.data.dueDate);
        },
        renderHeaderCell: () => {
          return t(`paymentHistory.dueDate`);
        },
        renderCell: (item) => {
          return (
            <Label size="small">{item.data.dueDate ? onFormatDate(new Date(item.data.dueDate), "BE") : "-"}</Label>
          );
        },
      }),
      createTableColumn({
        columnId: "total",
        compare: (a, b) => {
          return a.data.paidTotal - b.data.paidTotal;
        },
        renderHeaderCell: () => {
          return t(`paymentHistory.total`);
        },
        renderCell: (item) => {
          return (
            <TableCellLayout style={{display: "flex", justifyContent: "flex-end", paddingRight: 5}}>
              <Label size="small">{makeDecimalNumber(item.data.paidTotal)}</Label>
            </TableCellLayout>
          );
        },
      }),
      createTableColumn({
        columnId: "status",
        renderHeaderCell: () => {
          return "สถานะ"
        },
        renderCell: (item) => {
          if (item.data.status === "open" || item.data.status === "sent" || item.data.status === "partial-paid") {
            const timeNow = new Date().toISOString()
            if (timeNow > item.data.dueDate) {
              return (
                <TableCellLayout style={{display: "flex", paddingRight: 5}}>
                  <Label size="small" style={{ color: "red"}}>เกินกำหนดชำระ</Label>
                </TableCellLayout>
              )
            } else {
              return (
                <TableCellLayout style={{display: "flex", paddingRight: 5}}>
                  <Label size="small" style={{ color: "#106EBE"}}>รอชำระเงิน</Label>
                </TableCellLayout>
              )

            }
          } else if (item.data.status === "paid") {
            return (
              <TableCellLayout style={{display: "flex", paddingRight: 5}}>
                <Label size="small" style={{ color: "green"}}>ชำระแล้ว</Label>
              </TableCellLayout>
            )
          } else if (item.data.status === "void" || item.data.status === "uncollectible") {
            return (
              <TableCellLayout style={{display: "flex", paddingRight: 5}}>
                <Label size="small" style={{ color: "red"}}>ยกเลิก</Label>
              </TableCellLayout>
            )
          } else {
            return (
              <TableCellLayout style={{display: "flex", paddingRight: 5}}>
                <Label size="small">-</Label>
              </TableCellLayout>
            );
          }
        },
      }),
      createTableColumn({
        columnId: "file",
        renderHeaderCell: () => {
          return "";
        },
        renderCell: (item) => {
          return (
            <Link as='button' onClick={() => openFileBillingPdf(item)} >
              {t(`paymentHistory.details`)}
            </Link>
          );
        },
      }),
      createTableColumn({
        columnId: "receiptTaxInvoiceId",
        renderHeaderCell: () => {
          return "";
        },
        renderCell: (item) => {
          if (item.data.receiptTaxInvoiceId) {
            return (
              <Link as='button' onClick={() => openFileReceiptPdf(item)} >
                {t(`paymentHistory.receipt`)}
              </Link>
            );

          } else {
            return 
          }
        },
      }),
    ];

    function handleGoback(e) {
      history.push({
        pathname: '/billings/packages',
        state: {},
      });
    }

    return <div style={homeStyles}>
      {manual ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 21}}>
          {loading ? (
            <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
              <Spinner labelPosition="below" label={t(`paymentHistory.loading`)} />
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column"}}>
              <div style={{ marginBottom: 21}}>
                <Subtitle1>{t("paymentHistory.thisPageCannotReach")}</Subtitle1>
  
              </div>
              <div style={{ display: "flex", justifyContent: "center"}}>
                <Button 
                  appearance='primary' 
                  onClick={() =>  
                    history.push({
                      pathname: '/etax/documents/all',
                      state: {},
                    })}
                >
                  {t("paymentHistory.homepage")}
                </Button>
                
              </div>
            </div>
          )}
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center"}}>
            <div className={styles.root}>
              <Title1 as='h1'>
                <div style={{ display: "flex", flexDirection: "row", height: "100%"}}>
                  <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                    <History32Regular />
                  </div>
                  <div className={styles.verticalCenter}>
                    <div>
                      {t(`paymentHistory.paymentHistoryHeader`)}

                    </div>
                  </div>
                </div>
              </Title1>
                {/* <Title1 as='h1'>
                  <History32Regular />
                  ประวัติการชำระเงิน</Title1> */}
                <div className={styles.detail}>
                  <div className={mergeClasses(styles.vertical, styles.fullWidth, styles.columnGap)}>
                    <div onClick={handleGoback} style={{ display: "flex", flexDirection: "row"}}>
                      <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                        <ArrowLeftFilled />
                      </div>
                      <div className={styles.verticalCenter}>
                        <Body1>{t(`paymentHistory.back`)}</Body1>
                      </div>
                    </div>
                    {loading ? (
                      <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
                        <Spinner labelPosition="below" label={t(`paymentHistory.loading`)} />
                      </div>
                    ) : (
                      <>
                        <span><Body1Strong>{t(`paymentHistory.name`)}: </Body1Strong> <Body1>{companyData?.name || ""}</Body1></span>
                        <span><Body1Strong>{t(`paymentHistory.tel`)}: </Body1Strong> <Body1>{companyData?.phone || ""}</Body1></span>
                        <span><Body1Strong>{t(`paymentHistory.billingAddress`)}: </Body1Strong> <Body1>{companyData ? companyData.buildingNumber +
                                        ' ' +
                                        (!/^-*$/.test(companyData.address) && companyData.address.trim() && !/^-*$/.test(companyData.address.trim()) ? companyData.address + ' ' : '') +
                                        (!/^-*$/.test(companyData.streetName) && companyData.streetName.trim() && !/^-*$/.test(companyData.streetName.trim())
                                          ? companyData.streetPrefix + companyData.streetName + ' '
                                          : '') +
                                        companyData.subDistrictPrefix +
                                        companyData.subDistrictName +
                                        ' ' +
                                        companyData.districtPrefix +
                                        companyData.districtName +
                                        ' ' +
                                        companyData.provincePrefix +
                                        companyData.provinceName +
                                        ' ' +
                                        companyData.postcode : ""}</Body1></span>
                        <div>
                          <DataGrid
                            items={items}
                            columns={columns}
                            sortable
                            getRowId={(item) => item.number}
                            resizableColumns
                            columnSizingOptions={columnSizingOptions}
                          >
                            <DataGridHeader>
                              <DataGridRow>
                                {({ renderHeaderCell, columnId }, dataGrid) =>
                                  dataGrid.resizableColumns ? (
                                    <Menu openOnContext>
                                      <MenuTrigger>
                                        <DataGridHeaderCell
                                          ref={(el) => (refMap.current[columnId] = el)}
                                        >
                                          {renderHeaderCell()}
                                        </DataGridHeaderCell>
                                      </MenuTrigger>
                                      <MenuPopover>
                                        <MenuList>
                                          <MenuItem
                                            onClick={dataGrid.columnSizing_unstable.enableKeyboardMode(
                                              columnId
                                            )}
                                          >
                                            Keyboard Column Resizing
                                          </MenuItem>
                                        </MenuList>
                                      </MenuPopover>
                                    </Menu>
                                  ) : (
                                    <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                                  )
                                }
                              </DataGridRow>
                            </DataGridHeader>
                            <DataGridBody>
                              {({ item, rowId }) => (
                                <DataGridRow
                                  key={rowId}
                                >
                                  {({ renderCell, columnId }) => (
                                    <DataGridCell focusMode={getCellFocusMode(columnId)}>{renderCell(item)}</DataGridCell>
                                  )}
                                </DataGridRow>
                              )}
                            </DataGridBody>
                          </DataGrid>
                        </div>
                      </>
                    )}
                  </div>
                </div>
            </div>

        </div>

      )}
    </div>
};

export default PaymentHistory;
